import React from 'react';
import BuildFinanceHomeSections from './BuildFinanceHomeSections';

const Home: React.FC = () => {
    return (
        <div className="landing-page">
            <BuildFinanceHomeSections />
        </div>
    );
};

export default Home;